/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { Component } from 'react';
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID} from '../../configs/const';
import {showEndorsementVideo} from "../../configs/casinoShowList";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
let oid = OPERATOR_ID.toLowerCase()


export default class LoginSportsThumbnailList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            operator: OPERATOR_ID,
            digitainURL: '',
            host:'',
            hostdom:'',
            clientWidth: document.documentElement.clientWidth,
        };
    }
    componentDidMount() {
        // const splited = window.location.host.split('.');
        // const host = splited[splited.length - 2];
        // const hostdom = splited[splited.length - 1];

        // this.setState({
        //     host: host, 
        //     hostdom: hostdom,
        //     digitainURL:  `https://sport.${host}.${hostdom}/js/Partner/${document.documentElement.clientWidth > 768 ? 'IntegrationLoader.min.js' : 'bootstrapper.min.js'}` //`https://digitain.${host}.${hostdom}/home${document.documentElement.clientWidth > 768 ? '' : 'M'}.html?token=`
        // }, () => {
        //     if(window.location.origin !== 'http://localhost:3000' && (window.location.pathname === '/auth' || window.location.pathname === '/')){
        //         this.addDigitainScript();
        //     }
        // });
    }

    // addDigitainScript(){
    //     const script = document.createElement("script");
    //           script.type = 'text/javascript';
    //           script.src = this.state.digitainURL;
    //           script.async = true;
    //           script.id = "digiScrpt";
    //         //   let digitainToken = this.state.digitainToken;
    //           script.onload = function() {
    //               const splited = window.location.host.split('.');
    //                 const host = splited[splited.length - 2];
    //                 const hostdom = splited[splited.length - 1];
    //             if(document.documentElement.clientWidth > 768){
    //                 var sp = [
    //                     ["server", `https://sport.${host}.${hostdom}/`],
    //                     ["token", ''],
    //                     ["currentPage", "Home"],
    //                     ["language", "en"],
    //                     ["timeZone", "4"],
    //                     ["isSuperTip", true],
    //                     ["deposit", "Deposit"],
    //                     ["oddsFormat", 0],
    //                     ["oddsFormatList", [1, 2, 3]],
    //                     ["onContentLoaded", "EventHandler"],
    //                     ["sportsBookView", "europeanView"],
    //                     ["fixedHeight", true],
    //                     ["clearSiteStyles", false],
    //                     ["theme", "light"],
    //                     ["parent", [`${host}.${hostdom}`, `digitain.${host}.${hostdom}`]],
    //                     ["login", function(){
    //                         document.getElementById('btnLoginb2cLogin').click();
    //                     },]
    //                 ];
    //                 window['SportFrame'].frame(sp);
    //             } else {
    //                 var params = {
    //                     server: `https://sport.${host}.${hostdom}/`,
    //                     containerId: "sport_div_iframe",
    //                     token: '',
    //                     defaultLanguage: "en",
    //                     timeZone: 4,
    //                     hashRouterDisabled: false,
    //                     bottomNavBar: true,
    //                     externalLinksOpenInside: true,
    //                     oddsFormatList: [1, 2, 3],
    //                     oddsFormat: 0,
    //                     theme: "dark",
    //                     parent: [`${host}.${hostdom}`, `digitain.${host}.${hostdom}`],
    //                     loginTrigger: function(){
    //                         document.getElementById('btnLoginb2cLogin').click();
    //                     },
                            
    //                 };
                
    //                 window['Bootstrapper'].bootIframe(params, { name: "Mobile" }, { height: "900px" });
    //             };

    //             // id="sport_div_iframe_mn" className='list-view iframe-loader'
    //             setTimeout(()=>{ 
    //                 document.getElementById('sport_div_iframe_mn').classList.remove("iframe-loader")
    //             }, 6000);

    //         }
    //         document.head.appendChild(script);
    // }
    openLoginModal(){
        document.getElementById('btnLoginb2cLogin').click();
    }

    componentWillUnmount(){
        // if(document.getElementById("sport_div_iframe").children.length > 0){
        //     if(!!document.getElementById("digiScrpt")){
        //         document.getElementById("digiScrpt").remove();
        //         document.getElementById("sport_div_iframe").children[0].remove();
        //     }
        //     if(!!document.getElementById("betslip-container-element")){
        //         document.getElementById("betslip-container-element").remove();
        //     }
        // }
    }

    render() {
        let endorsementSettings = {
            dots: this.state.clientWidth < 768 ? true : false,
            infinite: true,
            speed: 300,
            slidesToShow: this.state.clientWidth < 501 ? 1 : (this.state.clientWidth < 768 ? 2 : 4),
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 5000
        };
        return (
            <>
            
            <div className='login-mar-top100 bg-black'>
                    <section className='sportbook-livecasino'>
                        <div>
                            <img alt="Casino Banner" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/casino-banner-b2c.jpg"} />

                        </div>
                        {showEndorsementVideo && 
                            <div className="row">
                                <div className='col-12'>
                                    <p className='section-head__title'>ENDORSEMENT</p>
                                </div>
                                <div id='dvEndorsementVideos' className="carousel-inner">
                                    <Slider {...endorsementSettings}>
                                        <div className='img-slider slider-padding'>
                                            <video width="100%" controls>
                                                <source src={`${BASE_IMAGE_PATH}/${oid}/video/ferrari-video1.mp4`} type="video/mp4"/>
                                                {/* <source src={BASE_IMAGE_PATH +${oid}+/video/ferrari-video1.mp4"} type="video/mp4"/> */}
                                                {/* {`${BASE_IMAGE_PATH}/${oid}/uimg/${BRANDLOGOFILENAME}`} */}
                                                {/* <source src="mov_bbb.ogg" type="video/ogg"/> */}
                                                Your browser does not support HTML video.
                                            </video>
                                        </div>
                                        <div className='img-slider slider-padding'>
                                            <video width="100%" controls>
                                            <source src={`${BASE_IMAGE_PATH}/${oid}/video/ferrari-video2.mp4`} type="video/mp4"/>
                                                {/* <source src="mov_bbb.ogg" type="video/ogg"/> */}
                                                Your browser does not support HTML video.
                                            </video>
                                        </div>
                                        <div className='img-slider slider-padding'>
                                            <video width="100%" controls>
                                            <source src={`${BASE_IMAGE_PATH}/${oid}/video/ferrari-video3.mp4`} type="video/mp4"/>
                                                <source src="mov_bbb.ogg" type="video/ogg"/>
                                                Your browser does not support HTML video.
                                            </video>
                                        </div>
                                        <div className='img-slider slider-padding'>
                                            <video width="100%" controls>
                                            <source src={`${BASE_IMAGE_PATH}/${oid}/video/ferrari-video4.mp4`} type="video/mp4"/>
                                                <source src="mov_bbb.ogg" type="video/ogg"/>
                                                Your browser does not support HTML video.
                                            </video>
                                        </div>
                                    </Slider>
                                </div>
                            </div>
                        }
                        <div>
                            <div className="livecasino-container">
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/evoluation/evoluation1.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/betgames/betgames1.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/ezugi/ezugi1.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/vivo/vivo1.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="livecasino-item slots__item ">
                            <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/pragmatic/p1.jpg"} />
                            <div className='slots__bg'>
                                    <div className="slots__overlay">
                                        <div className="slots__favorite"></div> 
                                        <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                    </div>
                                </div>
                        </div> */}
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/evoluation/evoluation2.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/betgames/betgames2.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/ezugi/ezugi5.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/evoluation/evoluation5.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/vivo/vivo2.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/pragmatic/p2.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/evoluation/evoluation3.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/betgames/betgames3.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/ezugi/ezugi3.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/vivo/vivo3.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/pragmatic/p3.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/evoluation/evoluation4.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/ezugi/ezugi2.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>

                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/vivo/vivo7.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/vivo/vivo8.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/pragmatic/p5.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/pragmatic/p6.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/betgames/betgames9.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/betgames/betgames10.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/betgames/betgames11.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/pragmatic/p1.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="livecasino-item slots__item ">
                            <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/evoluation/evoluation8.jpg"} />
                            <div className='slots__bg'>
                                    <div className="slots__overlay">
                                        <div className="slots__favorite"></div> 
                                        <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                    </div>
                                </div>
                        </div> */}
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/vivo/vivo6.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="livecasino-item slots__item ">
                            <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/pragmatic/p8.jpg"} />
                            <div className='slots__bg'>
                                    <div className="slots__overlay">
                                        <div className="slots__favorite"></div> 
                                        <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                    </div>
                                </div>
                        </div> */}
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/betgames/betgames5.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/betgames/betgames6.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/evoluation/evoluation7.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/ezugi/ezugi6.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/ezugi/ezugi7.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/ezugi/ezugi4.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/pragmatic/p7.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/betgames/betgames12.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/vivo/vivo4.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/vivo/vivo5.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/evoluation/evoluation6.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/betgames/betgames7.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/betgames/betgames8.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/pragmatic/p4.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="livecasino-item slots__item ">
                            <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/ezugi/ezugi4.jpg"} />
                            <div className='slots__bg'>
                                    <div className="slots__overlay">
                                        <div className="slots__favorite"></div> 
                                        <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                    </div>
                                </div>
                        </div> */}
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/betgames/betgames4.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.openLoginModal() }}>Play</a>
                                        </div>
                                    </div>
                                </div>



                                {/* <div className="livecasino-item"><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/evoluation/evoluation9.jpg"} /></div> */}
                            </div>
                            {/* <div className='slots__games'>
                        <div className='slots__item'>
                            <div className="slots__bg" style={{backgroundImage: 'url("https://v2l.cdnsfree.com/genfiles/slots/games/46/img40887.jpg")'}}>
                                <img src="https://v2l.cdnsfree.com/genfiles/slots/games/46/ovr18335.png" className="slots__prov"/> 
                                <div className="slots__overlay">
                                    <div className="slots__favorite"></div> 
                                    <a href="javascript:void(0)" className="slots__btn">Play</a>
                                </div>
                            </div> 
                        </div>
                        <div className='slots__item'>
                            <div className="slots__bg" style={{backgroundImage: 'url("https://placeimg.com/600/600/tech/grayscale")'}}>
                                <img src="https://v2l.cdnsfree.com/genfiles/slots/games/46/ovr18335.png" className="slots__prov"/> 
                                <div className="slots__overlay">
                                    <div className="slots__favorite"></div> 
                                    <a href="javascript:void(0)" className="slots__btn">Play</a>
                                </div>
                            </div> 
                        </div>
                        <div className='slots__item'>
                            <div className="slots__bg" style={{backgroundImage: 'url("https://placeimg.com/600/700/arch/grayscale")'}}>
                                <img src="https://v2l.cdnsfree.com/genfiles/slots/games/46/ovr18335.png" className="slots__prov"/> 
                                <div className="slots__overlay">
                                    <div className="slots__favorite"></div> 
                                    <a href="javascript:void(0)" className="slots__btn">Play</a>
                                </div>
                            </div> 
                        </div>
                        <div className='slots__item'>
                            <div className="slots__bg" style={{backgroundImage: 'url("https://placeimg.com/600/300/nature")'}}>
                                <img src="https://v2l.cdnsfree.com/genfiles/slots/games/46/ovr18335.png" className="slots__prov"/> 
                                <div className="slots__overlay">
                                    <div className="slots__favorite"></div> 
                                    <a href="javascript:void(0)" className="slots__btn">Play</a>
                                </div>
                            </div> 
                        </div>
                        <div className='slots__item'>
                            <div className="slots__bg" style={{backgroundImage: 'url("https://placeimg.com/600/800/animals/grayscale")'}}>
                                <img src="https://v2l.cdnsfree.com/genfiles/slots/games/46/ovr18335.png" className="slots__prov"/> 
                                <div className="slots__overlay">
                                    <div className="slots__favorite"></div> 
                                    <a href="javascript:void(0)" className="slots__btn">Play</a>
                                </div>
                            </div> 
                        </div>
                        <div className='slots__item'>
                            <div className="slots__bg" style={{backgroundImage: 'url("https://placeimg.com/600/400/animals")'}}>
                                <img src="https://v2l.cdnsfree.com/genfiles/slots/games/46/ovr18335.png" className="slots__prov"/> 
                                <div className="slots__overlay">
                                    <div className="slots__favorite"></div> 
                                    <a href="javascript:void(0)" className="slots__btn">Play</a>
                                </div>
                            </div> 
                        </div>
                    </div> */}
                        </div>
                    </section>
                </div>
            
            </>
        )
    }
}
